import i18n from '@/utils/i18n';
import React from 'react';
import { Breadcrumb } from '@usepepper/sprout-kit-ui';

interface Props {
  title: string;
}

export const FinanceHubBreadcrumb: React.FC<Props> = ({ title }) => (
  <Breadcrumb>
    <Breadcrumb.Item>{i18n.t('finance_hub.title')}</Breadcrumb.Item>
    <Breadcrumb.Item current>{title}</Breadcrumb.Item>
  </Breadcrumb>
);
